export default "__VITE_ASSET__5bcdc737__"